import { defineAsyncComponent } from 'vue'

const componentCache = new Map()

function asyncView(key, loader) {
  if (!componentCache.has(key)) componentCache.set(key, defineAsyncComponent(loader))
  return componentCache.get(key)
}

async function transferRequestModel() {
  return (await import('@/logic/transfer/transfer_request/transfer_request')).TransferRequest
}

async function transferProofModel() {
  return (await import('@/logic/transfer/transfer_proof/transfer_proof')).TransferProof
}

const GENERIC_TRANSFER_VIEW = () => import('@/views/users/TransferRequestDetail.vue')

const TRANSFER_DETAIL_VIEWS = {
  CashWithdraw: () => import('@/views/users/CashWithdrawRequestDetailView.vue'),
  BankWithdraw: () => import('@/views/users/BankWithdrawRequestDetailView.vue'),
  CryptoWithdraw: () => import('@/views/users/CryptoWithdrawRequestDetailView.vue'),
  CashDeposit: () => import('@/views/users/CashDepositRequestDetailView.vue'),
  CryptoDeposit: () => import('@/views/users/CryptoDepositRequestDetailView.vue')
}

const TRANSFER_REQUESTS_REPORT = { name: 'Reports', params: { nav: 'TransferRequests' } }

export const DETAIL_PRESENTATIONS = [
  {
    param: 'transferDetail',
    detailRoutes: [
      'transfer-request-detail',
      'bank-withdraw-request-detail',
      'crypto-withdraw-request-detail',
      'crypto-deposit-request-detail',
      'cash-deposit-request-detail',
      'cash-withdraw-request-detail'
    ],
    resolveDetailRoute: async (id) => {
      try {
        const TransferRequest = await transferRequestModel()
        const transferRequest = await TransferRequest.getById(id)
        return TransferRequest.getRouteConfigByTransferRequest(transferRequest, 'detail')
      } catch (error) {
        console.error(error)
        return { name: 'transfer-request-detail', params: { id } }
      }
    },
    resolveHost: () => TRANSFER_REQUESTS_REPORT,
    resolveComponent: async (id) => {
      try {
        const TransferRequest = await transferRequestModel()
        const { transferRequestType } = await TransferRequest.getById(id)
        if (TRANSFER_DETAIL_VIEWS[transferRequestType]) {
          return asyncView(transferRequestType, TRANSFER_DETAIL_VIEWS[transferRequestType])
        }
      } catch (error) {
        console.error(error)
      }
      return asyncView('TransferRequest', GENERIC_TRANSFER_VIEW)
    }
  },
  {
    param: 'proofDetail',
    detailRoutes: ['transfer-proof-detail'],
    resolveDetailRoute: (id) => ({ name: 'transfer-proof-detail', params: { id } }),
    resolveHost: async (id) => {
      try {
        const TransferProof = await transferProofModel()
        const assetSymbol = (await TransferProof.getById(id))?.asset?.symbol
        if (assetSymbol) {
          return {
            name: assetSymbol === 'IRT' ? 'bank-transaction' : 'cash-transaction',
            params: { type: 'deposit', assetSymbol }
          }
        }
      } catch (error) {
        console.error(error)
      }
      return TRANSFER_REQUESTS_REPORT
    },
    resolveComponent: () =>
      asyncView('TransferProof', () => import('@/views/users/TransferProofDetail.vue'))
  },
  {
    param: 'orderDetail',
    detailRoutes: ['order-detail'],
    resolveDetailRoute: (id) => ({ name: 'order-detail', params: { id } }),
    resolveHost: () => ({ name: 'Orders' }),
    resolveComponent: () => asyncView('Order', () => import('@/views/users/OrderDetailView.vue'))
  },
  {
    param: 'reportDetail',
    detailRoutes: ['report-detail'],
    resolveDetailRoute: (id) => ({ name: 'report-detail', params: { id } }),
    resolveHost: () => TRANSFER_REQUESTS_REPORT,
    resolveComponent: () => asyncView('Report', () => import('@/views/users/ReportDetailView.vue'))
  }
]

export function presentationForDetailRoute(routeName) {
  if (!routeName) return null
  return DETAIL_PRESENTATIONS.find((presentation) => presentation.detailRoutes.includes(routeName))
}

export function presentationForQuery(query) {
  if (!query) return null
  for (const presentation of DETAIL_PRESENTATIONS) {
    const id = query[presentation.param]
    if (id != null && id !== '') return { presentation, id }
  }
  return null
}
